import { IProduct } from '../../../interfaces/catalog'
import { ItemCardProps } from '../ItemCard'

export const itemCardDefault: Partial<ItemCardProps> = {
  padding: 0,
  gap: 0,
  header: {
    padding: 0
  },
  body: {
    padding: '8px 12px'
  },
  footer: {
    padding: 8
  },
  name: {
    size: 14,
    variant: 'h2',
    lines: 2
  },
  description: {
    size: 12,
    lines: 2
  }
}

export const removeOutOfStockProducts = (items: IProduct[]) =>
  items.filter((item) => !item.outOfStock)
